import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Button, withTheme } from '@material-ui/core'
import styled from 'styled-components'

type Props = {
    text?: string
}

const BackButton: FC<Props> = ({ text = 'Back' }: Props) => {
    const history = useHistory()
    return (
        <StyledButton
            variant={'outlined'}
            size="medium"
            color="primary"
            onClick={() => history.goBack()}>
            &lt; {text}
        </StyledButton>
    )
}

const StyledButton = withTheme(styled(Button)`
    margin: ${props => props.theme.spacing(3, 0)};
`)

export default BackButton